module.exports = __webpack_public_path__ + "604009e97a496514815ea2f870d8a4f4.jpg";